import { useTranslation } from 'react-i18next';
import TrendArrow from './TrendArrow';
import { getDisplayValue } from './utils';
import DataCard, { DataCardDisplayProps } from './DataCard';

type AveragePerWeekProps = DataCardDisplayProps;

const AveragePerWeekCard = ({
  change,
  value,
  type,
  src,
  label,
  showEmpty = false,
  unit = '',
  noPreviousData = false,
}: AveragePerWeekProps) => {
  const { t } = useTranslation();

  return (
    <DataCard type={type}>
      <img className="image" src={src} alt={label} />
      <div className="w-full flex text">
        <div className="ml-6 max-w-[160px]">
          <p className="display-value">
            {showEmpty ? '— —' : getDisplayValue(value, unit)}
          </p>
          <p className="text-sm font-semibold align-top">{label}</p>
          {showEmpty && <p className="text-xs">{t('analytics.noValidData')}</p>}
          {!showEmpty && (
            <>
              {noPreviousData ? (
                <p className="text-xs">
                  {t('analytics.trafficAwarenessPage.overview.noPrevious')}
                </p>
              ) : (
                <TrendArrow
                  change={change}
                  label={t('analytics.fromThePreviousPeriod')}
                />
              )}
            </>
          )}
        </div>
      </div>
    </DataCard>
  );
};

export default AveragePerWeekCard;
